import * as d3 from 'd3'

export default {
  methods: {

    draw_Legends(selection, _data, cht) {

      let latest = _data.find(f => f.CDATE == this.timeline.cutoff.date)

      let item = selection
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.current.id}_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.legends.y})`)
      
      let x_ = 0

      // Normal
      if(this.legends.type == 'normal') {

        this.chart.styles.filter(f=> f.name).forEach((d,i)=> {
          item
          .append('rect')
          .attr('id', `ICON_${i}_${this.localId}`)
          .attr('x', x_)
          .attr('y', (d.type=='LINE') ? 3 : 0)
          .attr('width', 6)
          .attr('height', (d.type=='LINE') ? 1 : 6)
          .attr('fill', d.color).attr('stroke', d.color)

          item
          .append('text')
          .attr('id', `ITEM_${this.current.id}_${i}_${this.localId}`)
          .attr('transform', `translate(${x_ + 10}, ${3 + this.legends.tSize*0.36})`)
          .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
          .text(d.name)

          x_ = x_ + this.getNode(`#ITEM_${this.current.id}_${i}_${this.localId}`, 'width') + 20
        })

        let len = this.getNode(`#LEGEND_GROUP_${this.current.id}_${this.localId}`, 'width')
        if(this.legends.align == 'center') {
          d3.selectAll(`#LEGEND_GROUP_${this.current.id}_${this.localId}`)
          .attr('transform', `translate(${(this.chart.width/2) - (len/2)}, ${this.legends.y})`)
        }
        if(this.legends.align == 'right') {
          d3.selectAll(`#LEGEND_GROUP_${this.current.id}_${this.localId}`)
          .attr('transform', `translate(${this.chart.width - len - 1}, ${this.legends.y})`)
        }
      }

      // Bar Chart
      if(this.legends.type == 'bar') {

        this.legends.bar.cols.forEach((col,c)=> {
          item
          .append('rect')
          .attr('id', `ICON_${c}_${this.localId}`)
          .attr('x', x_).attr('y', 0)
          .attr('width', 6).attr('height', 6)
          .attr('fill', col.color).attr('stroke', col.color)

          item
          .append('text')
          .attr('id', `ITEM_${this.current.id}_${c}_${this.localId}`)
          .attr('transform', `translate(${x_ + 10}, ${3 + this.legends.tSize*0.36})`)
          .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
          .text(col.name)

          x_ += this.getNode(`#ITEM_${this.current.id}_${c}_${this.localId}`) + 15

          item
          .append('rect')
          .attr('x', x_).attr('y', -1.5)
          .attr('width', this.legends.bar.length).attr('height', 9)
          .attr('fill', '#F4F5F5')

          let pro = latest[col.actCode]>0 ? (latest[col.actCode] / latest[this.legends.bar.total.code]) * this.legends.bar.length : 0
          item
          .append('rect')
          .attr('x', x_).attr('y', -1.5)
          .attr('width', pro).attr('height', 9)
          .attr('fill', col.color).attr('opacity', col.opacity)

          item
          .append('text')
          .attr('x', pro <= this.legends.bar.shift ? x_ + pro +1: x_ + pro -1)
          .attr('y', 3 + this.legends.tSize*0.36)
          .attr('text-anchor', pro <= this.legends.bar.shift ? 'start' : 'end')
          .attr('font-size', this.legends.bar.tSize).attr('fill', this.legends.bar.tColor)
          .text(latest[col.actCode])

          d3.select(`#TITLE_TOTAL_${cht.id}_${this.localId}`).text(latest[this.legends.bar.total.code])
          x_ += this.legends.bar.length + 15
        })

      }


    },

  }
}
